<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Inspection - ' + inspection.InspectionId + ' :: MeritEHS'" />

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/inspections`">
                            <i class="fa fa-list"></i> Inspections
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/inspections/view/${inspection.InspectionId}`">
                            <inspection-name :inspection="inspection" />
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        <i class="fa fa-trash"></i> Delete
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-4 col-lg-6">
                    <div class="alert alert-warning">
                        <p><strong>Warning:</strong> You are about to delete this inspection and all of its data. This change <strong>cannot be undone and cannot be recovered.</strong></p>

                        <div class="form-group">
                            <label :class="{ 'control-label': true, 'text-danger': errors.confirm_delete }">To Confirm Deletion, Type <i>delete</i> into the text field below:</label>
                            <input type="text" v-model="confirm_delete" name="confirm_delete" :class="{ 'form-control': true, 'is-invalid': errors.confirm_delete }" placeholder="Enter 'delete' to confirm you want to delete this inspection." />

                            <span v-if="errors.confirm_delete" class="text-danger">
                                <span v-for="error in errors.confirm_delete">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <b-button variant="danger" v-on:click="deleteInspection()" :disabled="saving">
                        <template v-if="saving">
                            Deleting...
                        </template>
                        <template v-else>
                            <i class="fa fa-trash"></i> Delete Inspection
                        </template>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                confirm_delete: null,
                inspectionId: this.$route.params.id,
                inspection: {},
                errors: {},
            }
        },

        methods: {

            getInspection() {
                //Get the data
                this.$http
                    .get('inspections/view/' + this.inspectionId)
                    .then(response => {
                        //Set all the data
                        this.inspection = response.data.inspection;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteInspection() {
                //SHow loading
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .post('inspections/delete/' + this.inspectionId, {confirm_delete: this.confirm_delete})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Inspection Deleted');

                    //Return to main list?
                    this.$router.push('/inspections');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.error(error.response.data, 'Failed to Delete Inspection');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },
        mounted() {
            //Get the inspection
            this.getInspection();
        }
    }
</script>
